import { ProductType } from '@inter-ikea-storageone/range';
import { ProductListConfig } from 'rangeConfig/@types';
import addProduct from 'rangeConfig/bror/behaviors/addProduct';
import CabinetDescription from '../../widgets/cabinetDescription';

const interiorsProductListConfig: ProductListConfig = {
  cluster: ['type'],
  cardsSubtitle: 'typeName, designText',
  behaviors: {
    productClicked: [addProduct],
    productDropped: [addProduct]
  },
  infoButtonAriaLabel: 'storageone.productListInteriorsTitle',
  sortOrder: [{ path: 'dimensions.height' }],
  categories: [
    {
      id: 'cabinetsAndShelvesBlack',
      categoryTitle: 'designText typeName',
      products: [
        { path: 'type', value: ProductType.BROR_SHELF_BLACK_PINE },
        { path: 'type', value: ProductType.BROR_SHELF_METAL_BLACK },
        { path: 'type', value: ProductType.BROR_DRAWER_METAL_BLACK }
      ]
    },
    {
      id: 'cabinetsAndShelvesGreyGreen',
      categoryTitle: 'designText typeName',
      products: [{ path: 'type', value: ProductType.BROR_SHELF_GREEN_PINE }]
    },
    {
      id: 'interiors-cabinetsBlack',
      categoryTitle: 'designText typeName',
      products: [{ path: 'type', value: ProductType.BROR_CABINET_BLACK }],
      widgets: [
        {
          component: CabinetDescription
        }
      ]
    },
    {
      id: 'interiors-cabinetsGreyGreen',
      categoryTitle: 'designText typeName',
      products: [{ path: 'type', value: ProductType.BROR_CABINET_GREEN }],
      widgets: [
        {
          component: CabinetDescription
        }
      ]
    }
  ],
  productFilters: []
};

export default interiorsProductListConfig;
